import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import {
  EventosI,
  EventosPersonalesI,
} from 'src/app/interfaces/eventos.interface';
import { BackendResponse } from 'src/app/interfaces/response.interface';
import { handleError } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AgendaService {
  constructor(private readonly http: HttpClient) {}

  private url = environment.url;

  insertAgenda(form: EventosPersonalesI) {
    const direction = this.url + 'eventos-personales';
    return this.http.post<BackendResponse>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as EventosPersonalesI)
    );
  }

  insertAgendaGral(form: EventosPersonalesI) {
    const direction = this.url + 'eventos-generales';
    return this.http.post<BackendResponse>(direction, form).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as EventosPersonalesI)
    );
  }

  getAgenda(params: HttpParams) {
    const direction = this.url + 'eventos-personales';
    return this.http.get<BackendResponse>(direction, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as EventosI[])
    );
  }

  getAgendaByMonth(params: HttpParams) {
    const direction = this.url + 'eventos-personales/by/month';
    return this.http.get<BackendResponse>(direction, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }

  getAgendaByWeek(params: HttpParams) {
    const direction = this.url + 'eventos-personales/by/week';
    return this.http.get<BackendResponse>(direction, { params }).pipe(
      catchError((e) => handleError(e)),
      map((data) => data.result as any)
    );
  }

  deleteEvento(id: number) {
    const direction = this.url + `eventos-personales/${id}`;
    return this.http
      .delete<BackendResponse>(direction)
      .pipe(catchError((e) => handleError(e)));
  }
}
